export default __webpack_public_path__ + "static/media/lg_hhid.938f4f99.csv";